/**
 *
 * UserData
 *
 * @namespace UserData
 */
var UserData = function(_userData, _type) {

    this.id = null;
    this.name = null;
    this.localName = null;
    this.email = null;
    this.accountType = null;
    this.country = null;
    this.priceType = null;
    this.customerType = null;
    this.eid = null;
    this.adminMode = false;
    this.lastName = null;
    this.firstName = null;
    this.personID = null;
    this.federatedId = null;
    this.temporary = true;

    function setNuskinAccountData(userData, data) {
        userData.id = data.user.id;
        userData.eid = data.user.eid;
        userData.name = data.user.displayName;
        userData.localName = data.user.localName;
        userData.email = data.user.email;
        userData.accountType = data.user.accountType;
        userData.country = data.user.countryCd;
        userData.priceType = data.user.priceType;
        userData.customerType = '';
        userData.firstName = data.user.firstName;
        userData.lastName = data.user.lastName;
    }

    function setGigyaData(userData, data) {
        userData.id = data.account.id;
        userData.eid = data.eid;
        userData.name = data.account.preferredName;
        userData.localName = data.person.localName;
        userData.email = getEmailFromContacts(data.account.contacts);
        userData.accountType = data.account.customerType;
        userData.country = data.account.country;
        userData.priceType = data.account.priceType;
        userData.customerType = data.account.customerType;
        userData.firstName = getFirstNameFromName(data.account.preferredName);
        userData.lastName = getLastNameFromName(data.account.preferredName);
        userData.personId = data.person.personID;
        userData.federatedId = data.person.gigyaUID;
        userData.temporary = data.account.temporary;
    }

    function setSimpleBeData(userData, data) {
        userData.id = data.businessEntity.id;
        userData.eid = data.businessEntity.encryptedId;
        userData.name = data.businessEntity.name;
        userData.localName = data.businessEntity.localName;
        userData.email = data.businessEntity.email;
        userData.accountType = data.businessEntity.accountType;
        userData.country = data.businessEntity.countryCd;
        userData.priceType = data.businessEntity.priceType;
        userData.customerType = data.businessEntity.customerType;
        userData.firstName = getFirstNameFromName(data.businessEntity.name);
        userData.lastName = getLastNameFromName(data.businessEntity.name);
    }

    function setLiteData(userData, data) {
        userData.id = data.id;
        userData.eid = data.eid;
        userData.adminMode = data.adminMode;
        userData.name = data.name;
        userData.localName = data.localName;
        userData.email = data.email;
        userData.accountType = data.accountType;
        userData.country = data.country;
        userData.priceType = data.priceType;
        userData.customerType = data.customerType;
        userData.firstName = data.firstName;
        userData.lastName = data.lastName;
    }

    function getFirstNameFromName(name) {
        return name.substring(name.indexOf(',') + 1).trim();
    }

    function getLastNameFromName(name) {
        return name.substring(0, name.indexOf(',')).trim();
    }

    function getEmailFromContacts(contacts) {
        var email = null;
        if (contacts && contacts.length) {
            for (var i = 0; i < contacts.length; i++) {
                if (contacts[i].type == 'EMAIL') {
                    email = contacts[i].value;
                }
            }
        }
        return email;
    }

    if (_type === 'nuskin.account') {
        setNuskinAccountData(this, _userData);
    } else if (_type === 'gigya') {
        setGigyaData(this, _userData);
    } else if (_type === 'simple.be') {
        setSimpleBeData(this, _userData);
    } else if (_type === 'lite') {
        setLiteData(this, _userData);
    }
};

export default UserData;
